<template>
  <div class="net-body">
    <div class="choose">
      <span :class="choose==0?'choosed':''" @click="toggle(0)">代接服务列表</span>
      <span :class="choose==1?'choosed':''" @click="toggle(1)">已接服务列表</span>
    </div>

    <div class="ready" v-show="choose==0">
      <div class="ready-template" v-for="(data,index) in datas" :key="index">
        <p>
          <span>姓名:</span>
          {{data.submitterName}}
        </p>
        <p>
          <span>电话:</span>
          {{data.submitterPhone}}
        </p>
        <p>
          <span>社区:</span>
          {{data.submitterType}}
        </p>
        <p>
          <span>地址:</span>
          {{data.submitterAddress}}
        </p>
        <button>我要接单</button>
      </div>
    </div>

    <div class="allready" v-show="choose==1">
      <div class="allready-template" v-for="(data,index) in alDates" :key="index">
        <p>
          <span>姓名:</span>
          {{data.submitterName}}
        </p>
        <p>
          <span>电话:</span>
          {{data.submitterPhone}}
        </p>
        <p>
          <span>社区:</span>
          {{data.submitterType}}
        </p>
        <p>
          <span>地址:</span>
          {{data.submitterAddress}}
        </p>
        <button>确认完结</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      choose: 0,
      datas: [],
      alDates: []
    };
  },
  methods: {
    toggle(value) {
      this.choose = value;
      switch (value) {
        case 0:
            this.getMsg()
          break;
        case 1:
            this.getAlreadey()
          break;
        default:
          break;
      }
    },
    getMsg() {
      this.axios
        .post("/api/Personal/Wait", {
          remark: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.datas = e.data.msg;
              break;
            default:
            //   alert(e.data.msg);
              break;
          }
        });
    },
    getAlreadey() {
      this.axios
        .post("/api/Personal/Receive", {
          remark: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.alDates = e.data.msg;
              break;
            default:
            //   alert(e.data.msg);
              break;
          }
        });
    }
  },
  mounted() {
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.net-body {
  .allready {
    .allready-template {
      button {
        border-radius: 0.16rem;
        border: none;
        padding: 0.1rem 0.2rem;
        background: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
        color: #fff;
        font-size: 0.28rem;
      }
      p {
        span {
          color: #999999;
        }
        font-size: 0.3rem;
        color: #000;
        line-height: 2;
        padding: 0 0.3rem;
      }
      width: 94%;
      margin: 0 auto;
      background: #fff;
      border-radius: 0.08rem;
      padding: 0 0.2rem;
    }
  }
  .ready {
    .ready-template {
      button {
        border-radius: 0.16rem;
        border: none;
        padding: 0.1rem 0.2rem;
        background: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
        color: #fff;
        font-size: 0.28rem;
      }
      p {
        span {
          color: #999999;
        }
        font-size: 0.3rem;
        color: #000;
        line-height: 2;
        padding: 0 0.3rem;
      }
      width: 94%;
      margin: 0 auto;
      background: #fff;
      border-radius: 0.08rem;
      padding: 0 0.2rem;
    }
  }
  .choose {
    margin-top: 0.1rem;
    display: flex;
    align-items: center;
    background: #fff;
    span {
      width: 50%;
      text-align: center;
      color: #999999;
      line-height: 3;
    }
    .choosed {
      color: #ffa000;
      font-weight: bold;
    }
  }
  padding-top: 0.9rem;
  font-size: 0.3rem;
}
</style>